import React from "react";
import "./FiltersKeywordGroups.css";

function FiltersKeywordGroups({ keywordGroups, setKeywordGroups }) {

  // Add a new empty group
  const addGroup = () => {
    setKeywordGroups([...keywordGroups, []]);
  };

  // Remove a whole group
  const removeGroup = (groupIndex) => {
    if (keywordGroups.length === 1) return; // prevent deleting last group
    const updated = keywordGroups.filter((_, idx) => idx !== groupIndex);
    setKeywordGroups(updated);
  };

  // Add keyword inside a group
  const addKeyword = (groupIndex, keyword) => {
    const trimmed = keyword.trim();
    if (!trimmed) return;

    const updated = [...keywordGroups];
    // avoid duplicates inside a group
    if (!updated[groupIndex].includes(trimmed)) {
      updated[groupIndex].push(trimmed);
      setKeywordGroups(updated);
    }
  };

  // Remove a keyword from a group
  const removeKeyword = (groupIndex, keywordIndex) => {
    const updated = [...keywordGroups];
    updated[groupIndex].splice(keywordIndex, 1);
    setKeywordGroups(updated);
  };

  return (
    <div className="keyword-groups-wrapper">
      <label className="filter-label">
        Keyword Groups (AND between groups, OR inside group)
      </label>

      {keywordGroups.map((group, gIndex) => (
        <div key={gIndex} className="keyword-group-card">

          {/* Group header */}
          <div className="keyword-group-header">
            <span className="group-title">Group {gIndex + 1}</span>

            <button
              className="remove-group-btn"
              onClick={() => removeGroup(gIndex)}
              disabled={keywordGroups.length === 1}
            >
              ×
            </button>
          </div>

          {/* Keyword chips */}
          <div className="keyword-chips-container">
            {group.map((keyword, kIndex) => (
              <span key={kIndex} className="chip">
                {keyword}
                <button
                  className="chip-remove"
                  onClick={() => removeKeyword(gIndex, kIndex)}
                >
                  ×
                </button>
              </span>
            ))}
          </div>

          {/* Input box for adding new keyword */}
          <input
            className="keyword-input"
            placeholder="Type a keyword and press Enter"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addKeyword(gIndex, e.target.value);
                e.target.value = "";
              }
            }}
          />
        </div>
      ))}

      {/* Add group button */}
      <button className="add-group-btn" onClick={addGroup}>
        + Add Group
      </button>
    </div>
  );
}

export default FiltersKeywordGroups;
